import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  signal,
} from '@angular/core';
import {
  ActivatedRoute,
  Data,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { NavigationPanelComponent } from '../../components/navigation-panel/navigation-panel.component';
import { NotificationBellComponent } from '../../../shared/components/notification-bell/notification-bell.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-main-layout',
  imports: [RouterOutlet, NavigationPanelComponent, NotificationBellComponent],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainLayoutComponent {
  route = inject(ActivatedRoute);
  router = inject(Router);

  navEndEvents = toSignal(
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd))
  );
  firstChildRouteData = signal<Data | undefined>(undefined);

  constructor() {
    effect(async () => {
      this.navEndEvents();

      const data = await firstValueFrom(this.updateFirstChildRoute().data);
      this.firstChildRouteData.set(data);
    });
  }

  updateFirstChildRoute(): ActivatedRoute {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
}
